import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges
} from '@angular/core';
import {
    IQuote, IShortTraveller,
    ITotal1,
    ITotal2,
    ITraveller
} from "libraries/interfaces/watabilight/IWatabiLightBooking.interface";
import { Yii } from "libraries/interfaces/Yii";
import { FormControl, FormGroup } from "@angular/forms";
import { IAllTravellersValue } from "../../traveller/traveller.component";
import { INumberFieldSpecs } from "libraries/module/formbuilder/fields/number/INumberFieldSpecs";
import {
    TravellerDataTranslationService
} from "libraries/service/traveller-data-translation/traveller-data-translation.service";
import { IHolder } from "libraries/service/resources/booking/interfaces/IGetBookings";
import _cloneDeep from "lodash-es/cloneDeep";

class Wording {
    public readonly travellerTitle: string = Yii.t('wui-shared-js', 'Prix par voyageur');
    public readonly total: string = Yii.t('wui-shared-js', 'Prix total');
    public readonly originTotal: string = Yii.t('wui-shared-js', "Prix total d'origine");
    public readonly commission: string = Yii.t('wui-shared-js', "Commission d'origine");
    public readonly margin: string = Yii.t('wui-shared-js', 'Commission choisie');
    public readonly undefined: string = Yii.t('wui-shared-js', 'Non précisé');
    public readonly errorMargin: string = Yii.t('wui-shared-js', 'Erreur, marge négative, réinitialisation');
    public readonly reInit: string = Yii.t('wui-shared-js', 'Réinitialiser les prix aux valeurs initiales');
}

enum EFormControlName {
    total = "total",
    commission = "commission",
    margin = "margin",
    title = "title",
    currency = "currency",
    travellers = "travellers",
}

interface IPriceConfig {
    totalConfig: INumberFieldSpecs;
    commissionConfig: INumberFieldSpecs;
    marginConfig: INumberFieldSpecs;

    [travellerId: string]: INumberFieldSpecs;
}

interface IPriceValue {
    total: number;
    commission: number;
    margin: number;
    travellers?: ITravellerPrice;
}

interface ITravellerPrice {
    [travellerId: string]: number;
}

@Component({
    selector: 'watabilight-quote-details',
    templateUrl: './quote-details.component.html',
    styleUrls: [
        '../../../booking.component.scss',
        './quote-details.component.scss'
    ]
})
export class QuoteDetailsComponent implements OnInit, OnChanges {
    @Input()
    public id: number;
    @Input()
    public quote: IQuote;
    @Input()
    public travellers: ITraveller[];
    @Input()
    public form: FormGroup;
    @Input()
    public isEdit: boolean;
    @Input()
    public travellersForm: FormGroup;
    @Input()
    public isLatestOutputForAgency: boolean;

    @Output()
    public readonly onEdit: EventEmitter<number> = new EventEmitter<number>();

    public config: IPriceConfig;
    public formValue: IPriceValue;
    public isTotalEditable: boolean = false;

    public wording: Wording = new Wording();
    public currency: string;
    public travellerName: { [key: string]: string } = {};

    public displayNumber: {
        total: boolean;
        [key: string]: boolean;
    } = {
        total: true,
    };

    public travellerId: string[] = [];

    public reini: boolean = false;

    public errorNotification:
        { isError: boolean, message: string, val: number } = {isError: false, message: "", val: 0};

    constructor(
        private readonly travellerDataTranslationService: TravellerDataTranslationService,
    ) {
    }

    public ngOnInit(): void {

        this.setTravellerId();

        this.setCurrency();
        this.setTraveller();
        this.initFormControl();
        this.initFormFieldConfig();
        this.setTotal();
        this.setValue();

        this.onEdit.emit(2);
    }

    public setTravellerId(): void {
        this.travellerId = [];
        this.quote?.price?.retailAgency?.traveller?.forEach((value: IShortTraveller): void => {
            this.travellerId.push(value.id);
        });
        this.travellerId.sort();
    }

    public ngOnChanges(changes: SimpleChanges): void {
        this.setTraveller();
    }

    public update(): void {
        this.setTraveller();
    }

    public setCurrency(): void {
        this.currency = this.quote.currency ? this.quote.currency : this?.quote?.price?.retail?.total?.currency;
    }

    public reInitPrice(): void {
        this.reini = true;
        this.quote.price.retailAgency = _cloneDeep(this.quote.price.retail);
        this.setTotal();
        this.setValue();
        // setTimeout((): void =>{
        this.reini = false;
        this.onEdit.emit(2);
        // }, 50);
    }

    public initFormControl(): void {
        this.form.setControl(EFormControlName.title, new FormControl());
        this.form.setControl(EFormControlName.total, new FormControl());
        this.form.setControl(EFormControlName.commission, new FormControl());
        this.form.setControl(EFormControlName.margin, new FormControl());
        this.form.setControl(EFormControlName.currency, new FormControl());
        this.form.setControl(EFormControlName.travellers, new FormGroup({}));
        const travellersGroup: FormGroup = this.form.get(EFormControlName.travellers) as FormGroup;
        this.travellerId.forEach((id: string): void => {
            travellersGroup.setControl(id, new FormControl());
            this.displayNumber[id] = true;
        });
    }

    public initFormFieldConfig(): void {
        this.config = {
            totalConfig: this.getFieldConfig(this.form, EFormControlName.total),
            commissionConfig: this.getFieldConfig(this.form, EFormControlName.commission),
            marginConfig: this.getFieldConfig(this.form, EFormControlName.margin),
        };
        const travellersGroup: FormGroup = this.form.get(EFormControlName.travellers) as FormGroup;
        this.travellerId.forEach((value: string): void => {
            this.config[value] = this.getFieldConfig(travellersGroup, value);
        });
    }

    public getFieldConfig(form: FormGroup, fomControlName: string): INumberFieldSpecs {
        return {
            formGroup: form,
            formControlName: fomControlName,
            className: "watabiLightInput",
            fixed: 2,
            step: 5,
            unit: this.currency
        };
    }

    public setTotal(): void {
        this.patchValueIfExist(this.form, this.quote?.price?.retailAgency?.total, EFormControlName.total, 0);
        this.patchValueIfExist(this.form, this.quote?.price?.retailAgency?.totalCommission, EFormControlName.commission, 0);
        this.patchValueIfExist(this.form, this.quote?.price?.retailAgency?.profit, EFormControlName.margin, this.form.get(EFormControlName.commission).value);
        this.patchValueIfExistString(this.quote?.introduction?.title, EFormControlName.title);
        this.patchValueIfExistString(this.currency, EFormControlName.currency);

        const travellersGroup: FormGroup = this.form.get(EFormControlName.travellers) as FormGroup;
        if (this.quote?.price?.retailAgency?.traveller && this.quote?.price?.retailAgency?.traveller?.length > 0) {
            this.quote.price.retailAgency.traveller.forEach((value: IShortTraveller): void => {
                if (value.total) {
                    this.patchValueIfExist(travellersGroup, value.total, value.id, 0);
                } else {
                    this.isTotalEditable = true;
                    this.patchValueIfExist(travellersGroup, value.total, value.id, null);
                }
            });
        } else {
            this.isTotalEditable = true;
        }
    }

    // tslint:disable-next-line:no-any
    public patchValueIfExist(form: FormGroup, value: ITotal2 | ITotal1, key: string, defaultVal: any): void {
        if (value && value.value) {
            form.get(key).setValue(value.value / 100);
        } else {
            form.get(key).setValue(defaultVal);
        }
    }

    public patchValueIfExistString(value: string, key: string): void {
        if (value) {
            this.form.get(key).setValue(value);
        }
    }

    public setTraveller(): void {
        const allTravellerValue: IAllTravellersValue = this.travellersForm.value;
        Object.keys(allTravellerValue).forEach((key: string): void => {
            this.travellerName[key] = this.travellerDataTranslationService.getTravellerIdentity(allTravellerValue[key] as unknown as IHolder);
        });
    }

    public editPrice(id: string): void {
        let total: number = 0;
        Object.keys(this.travellerName).forEach((idItem: string): void => {
            total += Number(this.form.value.travellers[idItem]);
        });
        this.editQuote(total, id);
    }

    public editTotal(): void {
        const total: number = this.form.value[EFormControlName.total];
        this.editQuote(total, "total");
    }

    public editQuote(total: number, id: string): void {
        const val: number = this.quote?.price?.retail?.total?.value;
        const totalTo: number = val ? val / 100 : 0;
        let commissionTo: number = this.quote?.price?.retail?.totalCommission?.value;
        commissionTo = (commissionTo === undefined ? 0 : commissionTo / 100);

        const newVal: IPriceValue = {
            total,
            commission: commissionTo,
            margin: (total - totalTo) + commissionTo
        };

        if (newVal.margin < 0) {
            this.displayNumber[id] = false;
            if (id === "total") {
                this.form.get(id).patchValue(this.formValue[id] / 100);
            } else {
                this.form.get(["travellers", id]).patchValue(this.formValue.travellers[id] / 100);
            }
            this.setError(true, this.wording.errorMargin, newVal.margin * 100);
            setTimeout((): void => {
                this.displayNumber[id] = true;
            }, 50);
            return;
        }

        this.setError(false, "", 0);
        this.form.patchValue(newVal);
        this.setValue();

        this.onEdit.emit(2);
    }

    public setError(bool: boolean, msg: string, val: number): void {
        this.errorNotification = {
            isError: bool,
            message: msg,
            val
        };
    }

    public setValue(): void {
        this.formValue = {
            [EFormControlName.total]: this.form.value[EFormControlName.total] * 100,
            [EFormControlName.commission]: this.form.value[EFormControlName.commission] * 100,
            [EFormControlName.margin]: this.form.value[EFormControlName.margin] * 100,
            travellers: {}
        };
        this.quote.price.retailAgency.traveller.forEach((value: IShortTraveller): void => {
            this.formValue.travellers[value.id] = this.form.value[value.id] === this.wording.undefined ?
                this.form.value.travellers[value.id] :
                this.form.value.travellers[value.id] * 100;
        });
    }

}
